import { Navigate, Outlet } from "react-router-dom";
import Loader from "../components/Loader";
import { useEffect } from "react";
import { setPurlUser } from "../store/reducers/purlUserReducer";
import { useGetDashboardDataQuery } from "../services/api";
import { useAppDispatch, useAppSelector } from "../store/store";

const PurlAuthHandler = ({ isProtected }: { isProtected: boolean }) => {
  const dispatch = useAppDispatch();
  const { zohoCustomerId } = useAppSelector((state) => state.login);

  const { data: dashboardData, isLoading: dashboardLoader } =
    useGetDashboardDataQuery(zohoCustomerId, {
      skip: !zohoCustomerId,
    });

  const setPurlUserReducer = (purlUser: IPurlUser) => {
    const purlData = {
      contactOwnerId: purlUser.Contact_Owner_ID,
      email: purlUser.Email,
      pinNew: purlUser.Pin_new,
      contactGroup: purlUser.Contact_Group,
      firstName: purlUser.First_Name,
      advisorName: purlUser.Advisor_Name,
      phone: purlUser.Phone,
      contactOwnerRole: purlUser.Contact_Owner_Role,
      bookkeeperPin: purlUser.Bookkeeper_Pin,
      contactOwnerZUID: purlUser.Contact_Owner_ZUID,
      creatorId: purlUser.CREATORID,
      solarStudyInvite: purlUser.Solar_Study_Invite,
      cpaEmail: purlUser.CPA_Email,
      advisorPin: purlUser.Advisor_Pin,
      advisorEmail: purlUser.Advisor_Email,
      advisorPhone: purlUser.Advisor_Phone,
      contactOwnerEmail: purlUser.Contact_Owner_Email,
      cpaPin: purlUser.CPA_Pin,
      solarStudyId: purlUser.Solar_Study_ID,
      contactOwnerPhone: purlUser.Contact_Owner_Phone,
      modifiedTime: purlUser.MODIFIEDTIME,
      bookkeeperName: purlUser.Bookkeeper_Name,
      bookkeeperEmail: purlUser.Bookkeeper_Email,
      cpaPhone: purlUser.CPA_Phone,
      pin: purlUser.Pin,
      contactOwner: purlUser.Contact_Owner,
      lastName: purlUser.Last_Name,
      uniqueId: purlUser.Unique_ID,
      crmContactId: purlUser.crm_Contact_ID,
      rowId: purlUser.ROWID,
      cpaName: purlUser.CPA_Name,
      entityName: purlUser.Entity_Name,
    };
    dispatch(setPurlUser(purlData));
  };

  useEffect(() => {
    dashboardData?.data.zohoData &&
      setPurlUserReducer(dashboardData?.data.zohoData);
  }, [dashboardData]);

  if (dashboardLoader)
    return (
      <div className="h-dvh">
        <Loader isLoading={true} />
      </div>
    );

  if (isProtected) {
    return zohoCustomerId ? <Outlet /> : <Navigate to="/" replace />;
  }

  return zohoCustomerId ? (
    <Navigate to={`/${zohoCustomerId}`} replace />
  ) : (
    <Outlet />
  );
};

export default PurlAuthHandler;
